export default __webpack_public_path__ + "static/media/two.dc3295a7.svg";